import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import MainHeader from "./MainHeader";
import useApp from "../../utils/useApp";
import StickyMenu from "./StickyMenu";

const RequireAuth2fa = ({ showToast }: any) => {
  const { auth }: any = useApp();
  const location = useLocation();

  return auth?.profile && auth?.twofactor ? (
    <>
      {!showToast && <StickyMenu />}
      <MainHeader />
      <Outlet />
    </>
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth2fa;
